// extracted by mini-css-extract-plugin
module.exports = {"noDataContent":"noDataContent__BUZP4","container":"container__g6eV-","icon":"icon__5OrOJ","title":"title__ayknE","description":"description__0rTb9","content":"content__B+U0K"};